import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import "./ui.css";

// Shared modal shell (header/body/footer). Re-declares the critical color
// tokens on its own overlay root (see ui.css's .ui-modal-overlay) instead
// of only relying on inheriting them from an ancestor -- a portaled
// react-bootstrap <Modal> losing --primary via the cascade was a
// confirmed, real bug elsewhere in the app (src/pages/forms/
// FormSubmissionViewPage.css), so this shell is self-contained by design.
export default function Modal({ show, onClose, title, footer, size, children }) {
  useEffect(() => {
    if (!show) return undefined;
    const onKeyDown = (e) => { if (e.key === "Escape") onClose?.(); };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [show, onClose]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="ui-modal-overlay"
          onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.18 }}
        >
          <motion.div
            className="ui-modal"
            role="dialog"
            aria-modal="true"
            aria-label={typeof title === "string" ? title : undefined}
            style={size === "lg" ? { maxWidth: 760 } : size === "sm" ? { maxWidth: 420 } : undefined}
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.96 }}
            transition={{ duration: 0.18, ease: "easeOut" }}
          >
            <div className="ui-modal-header">
              <h2 className="ui-modal-title">{title}</h2>
              <button type="button" className="ui-modal-close" aria-label="Close" onClick={onClose}>✕</button>
            </div>
            <div className="ui-modal-body">{children}</div>
            {footer && <div className="ui-modal-footer">{footer}</div>}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
